import { useMutation } from '@tanstack/react-query';
import { resendPartnerActivationEmail } from '../services/partners';

export const useResendPartnerActivationEmailMutation = (options = {}) =>
  useMutation({
    ...options,
    mutationFn: async ({ partnerProfileId }) => {
      const result = await resendPartnerActivationEmail({ partnerProfileId });
      if (!result.success) {
        throw new Error(result.message || 'Failed to send activation email');
      }
      return result;
    },
  });
